import * as z from 'zod';

import { InterestOnEscrowDepositHistoryItemId, PaymentId } from '../BrandedIds';
import { zodJSPlainDate } from '../dates/BrandedDate';

/**
 * Tracks the accrual period restart point after each interest on escrow deposit.
 * Items are appended in event-processing order. The last non-cancelled entry's
 * startOfNextAccrualPeriod determines where interest accrual restarts — used to
 * calculate cumulative accrued interest from that date to the report's end date.
 *
 * The cancelled flag is set to true when the corresponding deposit is reversed.
 */
export const InterestOnEscrowDepositHistoryItem = z.object({
  id: InterestOnEscrowDepositHistoryItemId,
  paymentId: PaymentId,
  startOfNextAccrualPeriod: zodJSPlainDate,
  cancelled: z.boolean().optional(),
});
export type InterestOnEscrowDepositHistoryItem = z.infer<typeof InterestOnEscrowDepositHistoryItem>;
